import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class TotalExposureValidator extends BaseValidator {
    private maxTotalExposure: number = 100;

    protected runValidation(): void {
        if (this.isTotalExposureExceeded()) {
            this.addError(`Total exposure cannot be greater than ${this.maxTotalExposure}%.`);
        }
    }

    private isTotalExposureExceeded(): boolean {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const items = stacking.getItems();

        let totalExposure = 0;
        for (let item of Object.values(items)) {
            // @ts-ignore
            totalExposure += item.getExposure();
        }

        return this.maxTotalExposure < totalExposure;
    }
}

export default TotalExposureValidator;
